import { AbstractBoardLane } from './abstract-board-lane.model';

export class ExistingRouteBoardLane extends AbstractBoardLane {}
